/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_State_UsedInputs */

const en_signin_state_used = /** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in link was already used. Ask for a new one.`)
};

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const ar_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const he_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const ur_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const es_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const fr_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const de_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const pt_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const hi_signin_state_used = en_signin_state_used;

/** @type {(inputs: Signin_State_UsedInputs) => LocalizedString} */
const bn_signin_state_used = en_signin_state_used;

/**
* | output |
* | --- |
* | "This sign-in link was already used. Ask for a new one." |
*
* @param {Signin_State_UsedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_state_used = /** @type {((inputs?: Signin_State_UsedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_State_UsedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_state_used(inputs)
	if (locale === "he") return he_signin_state_used(inputs)
	if (locale === "ur") return ur_signin_state_used(inputs)
	if (locale === "es") return es_signin_state_used(inputs)
	if (locale === "fr") return fr_signin_state_used(inputs)
	if (locale === "de") return de_signin_state_used(inputs)
	if (locale === "pt") return pt_signin_state_used(inputs)
	if (locale === "hi") return hi_signin_state_used(inputs)
	if (locale === "bn") return bn_signin_state_used(inputs)
	return /** @type {LocalizedString} */ ("This sign-in link was already used. Ask for a new one.")
});